import React from "react";

import { Input } from "@revvsales/components";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class NumberFieldFormMode extends React.Component {
  state = {
    numberfieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value) || value === "") {
      const { id } = this.props.initialProps;
      this.props._updateDynamicFieldsInDoc(id, parseInt(value, 10));
      this._checkForUpdateField(parseInt(value, 10));
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      if (currentValue) {
        this.props.filledStatus(true);
      } else {
        this.props.filledStatus(false);
      }
    }
  };

  render() {
    const {
      id,
      label,
      placeholder /* docIsLocked */,
    } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.numberfieldValues}
          customFieldName="NUMBER"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <Input
                  id={id}
                  name="default"
                  type="number"
                  className="form-mode-input"
                  // {`form-mode-input ${
                  //   messages.default && messages.default.required !== ""
                  //     ? "danger-border"
                  //     : ""
                  // }`}
                  placeholder={`${placeholder || `Enter ${label}`}`}
                  onChange={event => handleChange(event)}
                  onBlur={event =>
                    this._handleOnBlur(
                      event,
                      values.default,
                      handleBlur,
                      !messages.default,
                    )
                  }
                  value={values.default}
                  disabled={this.props.isLocked}
                  autoFocus
                  data-test="number-field-form-mode"
                />
                {/* <div>
                  {messages.default && (
                    <ErrorMessages messages={messages.default.required} />
                  )}
                </div> */}

                {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/NumberFieldFormMode.js